import { render, staticRenderFns } from "./pendientes.vue?vue&type=template&id=895aac2a&"
import script from "./pendientes.vue?vue&type=script&lang=js&"
export * from "./pendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports